import { render } from "./GiftEdit.vue?vue&type=template&id=99173d72"
import script from "./GiftEdit.vue?vue&type=script&lang=js"
export * from "./GiftEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__